import { createSelector } from 'reselect';

export const LICENCE_TO_AMEND_YOUR_FACE_ID = 126872;

const getQualities = ({ myself: { qualities } }) => qualities;

const inputFuncs = [getQualities];

const outputFunc = qualities => qualities.findIndex(
  q => q.id === LICENCE_TO_AMEND_YOUR_FACE_ID && q.effectiveLevel > 0,
) >= 0;


export default createSelector(inputFuncs, outputFunc);